import { useDebounceFunc } from "@hook";
import { changeValByPath } from "@utils";
import { inject, observer } from "mobx-react";

import ButtonUI from "@UI/ButtonUI";
import InputUI from "@UI/InputUI";
import SelectButtonUI from "@UI/SelectButtonUI";

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import HeaderTabs from "./HeaderTabs";

import "./style.scss";
import { useNavigationHandler } from "@hook";

const DefaultListHeader = inject("mainStore")(
    observer(({ selectButton = true, inputSearch = true, mainStore, titleName = "name", keyFilterSearch, counts }) => {
        const filter = mainStore.getMainStore("filter");

        const [input, setInput] = useState("");
        const { firstParam } = useParams();
        const navigation = useNavigationHandler();

        const value = filter?.headerSelect || "active";
        const isCompanies = firstParam === "companies" ? true : false;
        const isDraft = value == "draft" ? true : false;

        useEffect(() => {
            if (filter.filters[keyFilterSearch]) {
                // для возврата поисковой фразы в инпут
                setInput(filter.filters[keyFilterSearch]);
            }

            return () => mainStore.setMainStore("pagination", false);
        }, []);

        const setFilter = (arr) => {
            let newFilter = { ...filter };
            arr.forEach(({ path, value }) => {
                newFilter = changeValByPath(path, value, newFilter);
            });

            if (Object.keys(newFilter).length) mainStore.setMainStore(`filter`, newFilter);
        };

        const handleActiveFilter = (value) => {
            const arr = [...filterConfigs[value]];
            if (value === "inactive" && isCompanies) {
                mainStore.setMainStore("pagination", "active");
                arr.push({ value: 20, path: "rows" });
                arr.push({ value: 1, path: "first" });
            } else {
                mainStore.setMainStore("pagination", false);
                arr.push({ value: 200000, path: "rows" });
                arr.push({ value: 0, path: "first" });
            }

            if (value === "draft") {
                if (isCompanies) arr.push({ value: null, path: "filters.siteIds" }); // убиваем фильтр по партнерам на черновиках
            }

            arr.push({ value, path: "headerSelect" });
            setFilter(arr);
        };

        const debouncedSearch = useDebounceFunc((val) => {
            setFilter([{ value: val, path: `filters.${keyFilterSearch}` }]);
        }, 500);

        const handleSearch = (val) => {
            setInput(val);
            debouncedSearch(val);
        };

        const handleAddItem = (e) => {
            mainStore.setMainStore("detailData", {});
            mainStore.setMainStore("detaiDeflData", {});
            navigation(e, `/${firstParam}/add`);
        };

        const selectButtonTemplate = (item) => {
            const count = counts[item.value];

            return (
                <div className="header__count">
                    <span className="p-button-label p-c" data-pc-section="label">
                        {item.name}
                    </span>
                    {count != null && <div className="header__count-value">{count}</div>}
                </div>
            );
        };

        return (
            <div className="header">
                <div className="header__container">
                    <span className="header__title">{titleName}</span>
                    {selectButton && <SelectButtonUI value={value} itemTemplate={selectButtonTemplate} onChange={(e) => handleActiveFilter(e.value)} optionValue="value" optionLabel={`name`} options={optionsSelectButton} allowEmpty={false} />}
                    {inputSearch && <InputUI className="header__search" value={input} onChange={(e) => handleSearch(e.target.value)} placeholder="Название..." icon="pi pi-search" />}
                    <ButtonUI label={`Добавить`} severity="success" icon="pi pi-plus-circle" className="quick__block-button" onClick={handleAddItem} />
                </div>
                {isCompanies && !isDraft ? <HeaderTabs /> : null} {/*не показываем на черновиках*/}
            </div>
        );
    }),
);

const optionsSelectButton = [
    { name: `Активные`, value: "active" },
    { name: `Не активные`, value: "inactive" },
    { name: `Черновики`, value: "draft" },
];

const filterConfigs = {
    active: [
        { value: "true", path: "filters.active" },
        { value: "false", path: "filters.archived" },
        { value: "false", path: "filters.draft" },
    ],
    inactive: [
        { value: "false", path: "filters.active" },
        { value: "", path: "filters.archived" },
        { value: "false", path: "filters.draft" },
    ],
    draft: [
        { value: "false", path: "filters.active" },
        { value: "false", path: "filters.archived" },
        { value: "true", path: "filters.draft" },
    ],
};

export default DefaultListHeader;
